import { afterRenderEffect, Directive, ElementRef, inject, input } from '@angular/core';

/**
 * Applies the manual's video policy to the `<video>` elements inside the host: muted, looping,
 * inline and without controls. Under `prefers-reduced-motion: reduce` it also removes `autoplay`
 * and pauses them, so the examples stay as still frames.
 *
 * Bind the same html string the host renders (`[auManualVideos]="html"`): it is the signal that
 * re-applies the policy after the host's `innerHTML` changes.
 */
@Directive({ selector: '[auManualVideos]' })
export class ManualVideosDirective {
  readonly auManualVideos = input<string>();

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    afterRenderEffect(() => {
      this.auManualVideos();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.host.nativeElement.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.loop = true;
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');

        if (reducedMotion) {
          video.removeAttribute('autoplay');
          video.pause();
        }
      });
    });
  }
}
